(ns ncr.reports.explain-fragment
  (:require
   [cljs.core.async :as async :refer-macros [go]]
   [clojure.core.match :refer [match]]
   [clojure.set :as set]
   [clojure.string :as str]
   [uix.core.alpha :as uix]
   [tick.core :as t]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.pf :as pf]
   [ncr.etc.rhf :as rhf]
   [ncr.etc.modal :as m]
   [ncr.etc.alert :as a]
   [ncr.etc.util :as u]
   [ncr.backend :as b]
   [ncr.navigate :as n]
   [ncr.fragment.props.money.input :as mi]
   [ncr.fragment.props.date :as pd]
   [ncr.fragment.label :as fragment-label]
   [ncr.fragment.common :as fragment-common]
   [ncr.reports.common :as reports-common]
   [ncr.me :as me]))

(defn- c-new-fragment-body [{:keys [submit control] :as form} me]
  [pf/c-form {:on-submit submit}
   [pf/c-grid
    [pf/c-grid-item {:span 12}
     (let [id :name]
       [rhf/c-form-group {:label "Name" :is-required true :field-id id} :name form
        [fragment-common/c-name-input id form []]])]

    [:<>
     [rhf/c-controller
      {:name :value
       :control control
       :render
       (fn [props]
         [pf/c-grid-item {:span 6}
          (let [id :value]
            [rhf/c-form-group {:label "Value" :is-required true :field-id id} :value form
             [mi/c-inline-input-netto-brutto
              (let [[netto brutto] (-> props :field :value)]
                {:netto netto
                 :brutto brutto
                 :display-type :input-group
                 :display-netto :absolute
                 :display-brutto :absolute
                 :ignore-missing? false
                 :on-change
                 (fn [{:keys [netto brutto]}]
                   (go
                     ((-> props :field :on-change) [netto brutto])))})]])])}]

     [pf/c-grid-item {:span 6}
      [rhf/c-form-group {:label "Date" :is-required true :field-id :date} :value form
       [rhf/c-controller
        {:name :date
         :control control
         :render
         (fn [props]
           [pf/c-date-picker
            (merge
              (let [format #(or (some-> % t/date pd/to-string) "")]
                {:value
                 (some-> props :field :value format)
                 :placeholder ""
                 :date-format format
                 :date-parse pd/parse
                 :append-to #(.-body js/document)
                 :on-change
                 (fn [_ _ date]
                   ((-> props :field :on-change) date))}))])}]]]]
    (let [id :labels]
      [pf/c-grid-item {:span 12}
       [rhf/c-form-group {:label "Labels" :is-required false :field-id :labels} :labels form
        [fragment-label/c-labels-selector
         {:name :labels
          :form form
          :id id
          :dropup? true}
         (get-in me [:cluster :labels])]]])]])

(defn- c-new-fragment [me meta defaults]
  (let
    [ref (uix/ref)
     {:keys [submit watch] :as form}
     (rhf/use-form
       {:shouldFocusError false
        :default-values defaults})
     modal-id :new-fragment-modal]

    (m/use-submit-form modal-id ref submit)

    [m/c-modal
     {:title "Create and Accept Document"
      :variant :medium
      :is-overflow-visible false
      :id modal-id
      :ref ref
      :actions
      [[pf/c-button
        {:variant :primary
         :is-disabled
         (let
           [[name [netto _] date labels] (watch [:name :value :date :labels])
            labels (into #{} labels)
            {:keys [labels-income labels-expense labels-directional]} meta]

           (or
             (str/blank? name)
             (nil? netto)
             (nil? date)

             (empty?
               (set/intersection labels labels-directional))

             (and
               (seq (set/intersection labels labels-income))
               (seq (set/intersection labels labels-expense)))))
         :on-click submit}
        "Create"]

       [pf/c-button
        {:variant :link :on-click #(m/close! nil)} "Cancel"]]}
     [c-new-fragment-body form me]]))

(defn create-fragment! [me {:keys [name netto labels month meta]}]
  (go
    (let
      [year (-> meta :rdef :year)
       defaults
       {:name (u/format "%s / %s" name (get reports-common/months (dec month)))
        :value [(.abs netto) nil]
        :labels labels
        :date (and year month (t/new-date year month 15))}]
      (if-let [{:keys [name labels value date]} (<! (m/!modal #'c-new-fragment me meta defaults))]
        (u/error-m
          [progress (a/progress {:title "Create and Accept Document"})
           _
           (<!
             (a/!operation*
               {:success-title "Document Created and Accepted"
                :body-fn
                (fn [id]
                  [:a
                   {:href
                    (n/fragment-href
                      {:slug (fragment-common/fragment-name->slug name)
                       :id id})}
                   name])}
               progress
               (go
                 (u/error-m
                   [response
                    (<!
                      (b/!multi-mutation
                        [[:document
                          [:fragment_create
                           {:name :$name
                            :labels labels
                            :folder (-> me me/inbox-folder :id)}
                           [:id]]]
                         [:properties
                          [:properties_patch
                           {:reference :?document-id
                            :properties
                            (let [[netto brutto] value]
                              (u/transit-write
                                {:common/netto netto
                                 :common/brutto brutto
                                 :common/date (t/date date)}))}]]
                         [:promote
                          [:reference_quick_promote
                           {:id :?document-id}]]]
                        {:$name name}))]
                   (-> response :document :id)))))]
          (ps/pub! [:report/reload]))))))